import {
    PATH_AGENDA,
    PATH_COLABORADOR_DETAIL,
    PATH_CONTACTO_DETAIL,
    PATH_CUENTA_DETAIL,
    PATH_CUENTAS,
} from '../../navigation/navigation.module';
import { CUENTA_TYPE_PROVEEDOR } from '../../services/cuentas-service';
import { ColaboradoresService } from '../../services/colaboradores-service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationService } from '../../services/navigation-service';
import { DashboardService } from '../../services/dashboard-service';
import { DialogsService } from '../../services/dialogs-service';
import { AgendaService } from '../../services/agenda-service';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  @ViewChild('contribucionMiRedCircleProgress') contribucionMiRedCircleProgress;
  @ViewChild('contribucionUNCOCircleProgress') contribucionUNCOCircleProgress;
  showConsignasByContacto = true;

  ASSETS_URL = environment.ASSETS_URL;
  CUENTA_TYPE_PROVEEDOR = CUENTA_TYPE_PROVEEDOR;

  @ViewChild('evDatePicker') evDatePicker;
  evDate:Date = new Date();

  /** Consignas de Hoy */
  consignasHoy = [];

  /** Mis estadísticas */
  estadisticasConsignas = 0;
  estadisticasLogros = 0;
  estadisticasPuntos = 0;

  /** Mi Evolución */
  public miEvolucionData:Array<any> = [
    { data: [] }
  ];
  public miEvolucionLabels:Array<any> = [];
  public miEvolucionOptions:any = {
    responsive: true,
    elements: {
      line: {
          tension: 0 // disables bezier curves
      }
    }
  };
  public miEvolucionColors:Array<any> = [
    {
      backgroundColor: 'rgba(75, 129, 176, 0.5)',
      borderColor: 'rgba(75, 129, 176, 1)',
      pointBackgroundColor: 'rgba(75, 129, 176, 1)',
      pointBorderColor: 'rgba(75, 129, 176, 1)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];
  public miEvolucionLegend:boolean = false;
  public miEvolucionType:string = 'line';

  /** Contribución mi red */
  public contribucionMiRedPercentage: number = 0;

  /** Contribución en UNCO */
  public contribucionUNCOPercentage: number = 0;

  /** Logros Colaboradores */
  logrosColaboradores = [];

  constructor(private navigationService: NavigationService,
              private dashboardService: DashboardService,
              private agendaService: AgendaService,
              private router: Router,
              private dialogsService: DialogsService,
              private colaboradoresService: ColaboradoresService,
              private dateAdapter:DateAdapter<Date>) {
  }

  /** Colaboradores más cercanos */
  public colaboradoresMasCercanosData:Array<any> = [
    { data: [] }
  ];
  public colaboradoresMasCercanosLabels:Array<any> = [];
  public colaboradoresMasCercanosOptions:any = {
    responsive: true
  };
  public colaboradoresMasCercanosColors:Array<any> = [
    {
      backgroundColor: 'rgba(242, 152, 55, 0.5)',
      borderColor: 'rgba(242, 152, 55, 1)',
      pointBackgroundColor: 'rgba(242, 152, 55, 1)',
      pointBorderColor: 'rgba(242, 152, 55, 1)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(242, 152, 55, 1)'
    }
  ];
  public colaboradoresMasCercanosLegend:boolean = false;
  public colaboradoresMasCercanosType:string = 'radar';


  /** Cuentas más cercanas */
  public cuentasMasCercanasData:Array<any> = [
    {data: []}
  ];
  public cuentasMasCercanasLabels:Array<any> = [];
  public cuentasMasCercanasOptions:any = {
    responsive: true
  };
  public cuentasMasCercanasColors:Array<any> = [
    {
      backgroundColor: 'rgba(101, 75, 176, 0.5)',
      borderColor: 'rgba(101, 75, 176, 1)',
      pointBackgroundColor: 'rgba(101, 75, 176, 1)',
      pointBorderColor: 'rgba(101, 75, 176, 1)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(101, 75, 176, 1)'
    }
  ];
  public cuentasMasCercanasLegend:boolean = false;
  public cuentasMasCercanasType:string = 'radar';

  /** Consignas by Contacto */
  contactosConsignas = [];

  /** Consignas by Empresa */
  empresasConsignas = [];

  currentUserId = Number(localStorage.getItem('userId'));


  ngOnInit() {
    this.loadData();

    // Set datepicker locale to the one expected so it doesn't swap the day and
    // month when opening the calendar again, we hide the associated input anyways
    this.dateAdapter.setLocale('en-us');
  }

  loadData(){
    this.getConsignasHoy();
    this.getLogrosColaboradores();
    this.getMiEvolucion();
    this.getMisEstadisticas();
    this.getMiContribucion();
    this.getColaboradoresCercanos();
    this.getCuentasCercanas();
    this.getConsignasByContacto();
    this.getConsignasByEmpresa();
  }

  getConsignasHoy(){
    this.dashboardService.getConsignasHoy()
      .subscribe(data => {
        console.log(data);
        data.ResponseData.forEach(c => {
          c.showOwnerButtons = this.currentUserId === c.UsuarioCreadorId
        });
        this.consignasHoy = data.ResponseData;
      });
  }

  getLogrosColaboradores(){
    this.dashboardService.getLogrosColaboradores()
      .subscribe(data => {
        console.log(data);
        this.logrosColaboradores = data.ResponseData;
      });
  }

  getMiEvolucion(){
    // sunday is the first day of the week, so we throw some day math in here
    let start = moment(this.evDate).startOf('week').subtract(1, 'day').format('X');
    let end = moment(this.evDate).endOf('week').subtract(1, 'day').format('X');
    this.dashboardService.getMiEvolucion(start, end)
    .subscribe(data => {
      // Fill in the days of the week not returned by the API
      let tmp = Array.apply(null, {length: 7}).map((e, i) => {
        return {DayWeekNumber: i};
      }).map(e => {
        let c = data.ResponseData.find(d => d.DayWeekNumber === e.DayWeekNumber);
        return {...e, ...c};
      });

      console.log(data);
      this.miEvolucionLabels = [];
      let valuesArray = [];

      for(let value of tmp){

        let dayweek = '';
        switch(value.DayWeekNumber){
          case 0:
            dayweek = 'Domingo';
            break;
          case 1:
            dayweek = 'Lunes';
            break;
          case 2:
            dayweek = 'Martes';
            break;
          case 3:
            dayweek = 'Miércoles';
            break;
          case 4:
            dayweek = 'Jueves';
            break;
          case 5:
            dayweek = 'Viernes';
            break;
          case 6:
            dayweek = 'Sábado';
            break;
        }

        this.miEvolucionLabels.push(dayweek);
        valuesArray.push(value.Quantity || 0);
      }

      this.miEvolucionData = [
        { data: valuesArray }
      ];

      console.log(this.miEvolucionData);
      console.log(this.miEvolucionLabels);

    });
  }

  getMisEstadisticas(){
    this.colaboradoresService.getEstadisticasColaborador(localStorage.getItem('userId'))
      .subscribe(data => {
        let { ResponseData } = data;
        this.estadisticasConsignas = ResponseData.ConsignasCantidad;
        this.estadisticasLogros = ResponseData.LogrosPorcentaje;
        this.estadisticasPuntos = ResponseData.Puntos;
      });
  }

  getColaboradoresCercanos(){
    this.dashboardService.getColaboradoresCercanos()
      .subscribe(data => {
        console.log(data);
        this.colaboradoresMasCercanosLabels = data.ResponseData.map(val => val.ColaboradorName);
        this.colaboradoresMasCercanosData = [
          { data: data.ResponseData.map(val => val.Distancia) }
        ];

      });
  }

  getCuentasCercanas(){
    this.dashboardService.getCuentasCercanas()
      .subscribe(data => {
        console.log(data);
        this.cuentasMasCercanasLabels = data.ResponseData.map(val => val.EmpresaName);
        this.cuentasMasCercanasData = [
          { data: data.ResponseData.map(val => val.Distancia) }
        ];

      });
  }

  getConsignasByContacto(){
    this.dashboardService.getConsignasByContacto()
      .subscribe(data => {
        console.log(data);
        this.contactosConsignas = data.ResponseData;
      });
  }

  getConsignasByEmpresa(){
    this.dashboardService.getConsignasByEmpresa()
      .subscribe(data => {
        console.log(data);
        this.empresasConsignas = data.ResponseData;
      });
  }

  getMiContribucion(){
    this.dashboardService.getMiContribucion()
    .subscribe(data => {
      console.log(data);
      this.contribucionMiRedPercentage = data.ResponseData.ContribucionMiRed;
      this.contribucionUNCOPercentage = data.ResponseData.ContribucionUNCO;

      this.contribucionMiRedCircleProgress.animate();
      this.contribucionUNCOCircleProgress.animate();
    });
  }

  toggleNav(){
    this.navigationService.toggleNav(true);
  }

  onFinishConsigna(consigna){
    this.dialogsService.showRateConsignaDialog()
      .subscribe( res => {
          if (res){
            this.agendaService.rateConsigna(consigna.ConsignaId, res)
              .subscribe( data => {

              });
          }
      });
  }

  onDeleteConsigna(consigna){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta consigna?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.agendaService.deleteConsigna(consigna.Id)
            .subscribe( data => {
              this.getConsignasHoy();
            });
        }});
  }

  showNewConsignaDialog(){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES')
      .subscribe( () => {
        this.getConsignasHoy();
      });
  }

  navigateToAgenda(){
    this.router.navigate([PATH_AGENDA]);
  }

  openColaboradoresDialog(){
    this.dialogsService.showColaboradoresDialog();
  }

  openContactosDialog(){
    this.dialogsService.showContactosDialog();
  }

  openEmpresasDialog(){
    this.dialogsService.showEmpresasDialog();
  }

  navigateToCuentas(){
    this.router.navigate([PATH_CUENTAS]);
  }

  showEvolutionDatePicker(){
    this.evDatePicker.open();
  }

  navigateToColaborador(colaborador){
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.ColaboradorId]);
  }

  navigateToCuenta(cuenta){
    this.router.navigate([PATH_CUENTA_DETAIL, cuenta.EmpresaId]);
  }

  navigateToContacto(contacto){
    this.router.navigate([PATH_CONTACTO_DETAIL, contacto.ContactoId]);
  }

  prevWeek(){
    this.evDate = moment(this.evDate).subtract(1, 'week').toDate();
    this.getMiEvolucion();
  }

  nextWeek(){
    this.evDate = moment(this.evDate).add(1, 'week').toDate();
    this.getMiEvolucion();
  }

  updateEvolutionCalendar(){
    this.getMiEvolucion();
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/dashboard/dashboard.component.ts